import React from 'react';
import Navbar from './global-components/navbar-v3';
import PageHeader from './global-components/page-header';
import Transaction from './section-components/transaction';
import Footer from './global-components/footer';

const SignInPage = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Transaction List"  />
        <Transaction/>
        <Footer />
    </div>
}

export default SignInPage

